import React from 'react';
import c from '../w.js';

const IconCheck = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2071 7.20718L10 17.4143L4.29289 11.7072L5.70711 10.293L10 14.5859L18.7929 5.79297L20.2071 7.20718Z"
      }
    )
  )
);

export { IconCheck };
